module.exports = __webpack_public_path__ + "static/media/too-small.5fd327ff.jpg";